/*********************************************************************************************
 * Splide Collection - Initialisation
 *
 */
function initializeSplideSEO(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : false,
        perPage     : 1,
        fixedWidth  : 'fit-content',
        snap        : true,    
		omitEnd		: true,
        gap         : '8px',
        breakpoints: {
            768: {
                gap         : '6px',
            }
        }
    });

    // Sélecteur de la barre de progression (personnalisez selon vos besoins)
    var progressBar = document.querySelector(`.my-carousel-progress-bar`);
    var progressContainer = document.querySelector(`.my-carousel-progress`);

    // Met à jour la barre de progression à chaque mouvement du carousel
    splideInstance.on('mounted move', function () {
        var end  = splideInstance.Components.Controller.getEnd() + 1;
        var rate = Math.min((splideInstance.index + 1) / end, 1);
        if (progressBar) {
            progressBar.style.width = (rate * 100) + '%';
        }
    });

    splideInstance.mount();

    // Ajout du scroll horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	initializeSectionsWithSplide('data-section-seo', '.mm-seo-splide', initializeSplideSEO);
});